module.exports = __webpack_public_path__ + "img/yinbo.458aff8d.gif";